import cx from 'classnames';
import { FunctionComponent } from "react";
import useLinkProps from "../../../hooks/use-link-props";
import Link from "next/link";
import BPImage from "../../ui/v2/image";
import ProIcon from "../../ui/icons/pro-icon";
import Chevrelon from "../../ui/icons/cheverlon";
import useTranslation from 'next-translate/useTranslation';

const ProBanner: FunctionComponent = ({
}) => {
    const { t } = useTranslation();
    const getLink = useLinkProps();
    const proRegisterLink = getLink('pro');

    return <Link {...proRegisterLink
    } target='_blank' className='group' >
        <div className={cx('w-full relative bg-white mt-4 shadow border-neutral-10')}>
            <BPImage
                src={'/svg/banner-pa-bg.svg'}
                alt="image_bg_pa"
                fill={true}
                sizes="100%"
                className="object-cover object-[20px_-30px]"
                quality={100}
            />
            <div className={cx('relative w-full container mx-auto flex flex-col gap-3', 'p-4')}>
                <div className='flex flex-row justify-between items-center gap-2'>
                    <span className='font-bold group-hover:text-neutral-50'>{t('common:pro-banner.title')}</span>
                    <ProIcon className='h-4 group-hover:text-neutral-50'></ProIcon>
                </div>
                <div className='flex flex-row justify-between items-center gap-2'>
                    <span className='text-sm group-hover:text-neutral-50'>{t('common:pro-banner.subtitle')}</span>
                    <Chevrelon className='h-4 group-hover:text-neutral-50 -rotate-90' />
                </div>
            </div>
        </div>
    </Link >
}

export default ProBanner;